import { TextField } from "@material-ui/core";
import { useHistory } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { validateEmail } from "./validateEmail";
import usePasswordValidator from "./passwordutils";
import "../../stylesheets/signupform.css";
import axios from "axios";
import Alert from "@material-ui/lab/Alert";
import AlertTitle from "@material-ui/lab/AlertTitle";
import { Link } from "react-router-dom";
import Modal from "@material-ui/core/Modal";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// import LinearProgress from "@material-ui/core/LinearProgress";
import ReactGA from "react-ga";
import LoginwithGoogle from "./LoginwithGoogle";
import Typewriter from "typewriter-effect";

require("dotenv").config();
const DOMAIN = process.env.REACT_APP_DOMAIN;

function getModalStyle() {
  const top = 50;
  const left = 50;

  return {
    top: `${top}%`,
    left: `${left}%`,
    transform: `translate(-${top}%, -${left}%)`,
  };
}

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 350,
    textAlign: "center",
    backgroundColor: theme.palette.background.paper,
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    ["@media only screen and (max-width: 420px)"]: {
      width: 220,
      marginLeft: 0, // secondary
    },
  },
}));

// const BorderLinearProgress = withStyles((theme) => ({
//   root: {
//     height: 15,
//     borderRadius: 5,
//     marginTop: 20,
//     marginBottom: 20,
//   },
//   colorPrimary: {
//     backgroundColor:
//       theme.palette.grey[theme.palette.type === "light" ? 200 : 700],
//   },
//   bar: {
//     borderRadius: 5,
//     backgroundColor: "#1a90ff",
//   },
// }))(LinearProgress);

function Signup({ isAuth, setIsAuth }) {
  const history = useHistory();
  if (isAuth) {
    history.push("/profile/" + window.localStorage.getItem("id"));
  }
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [password, setPassword, passwordError] = usePasswordValidator({
    min: 8,
    max: 15,
  });
  const [resp, setResp] = useState("");
  const [mess, setMess] = useState("");
  const classes = useStyles();
  // getModalStyle is not a pure function, we roll the style only on the first render
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const [numUsers, setNumUsers] = React.useState("");
  const params = new URLSearchParams(window.location.search).get("referrer");
  const [referralID, setReferralID] = useState(params);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  //modal body

  useEffect(() => {
    ReactGA.pageview(window.location.pathname + window.location.search);

    axios
      .get(`${DOMAIN}/user_count`)
      .then((res) => {
        setNumUsers(res.data.activeUsers);
      })
  }, []);

  const body = (
    <div style={modalStyle} className={classes.paper}>
      {resp === "Verification Email has been sent to your given email." ? (
        <h2 id="simple-modal-title">SUCCESS</h2>
      ) : (
        <h2 id="simple-modal-title">Error Occured</h2>
      )}
      <p className="simple-modal-desc" id="simple-modal-description">
        {resp}
      </p>
      <div className="buttons">
        <Link
          to="/login"
          onClick={handleClose}
          style={{ textDecoration: "none", color: "black" }}
        >
          <button className="btn btn-primary btn-lg">Login</button>
        </Link>
      </div>
    </div>
  );

  useEffect(() => {
    if (!email) {
      setEmailError("");
    } else {
      if (validateEmail(email)) {
        setEmailError("");
      } else {
        setEmailError("Please enter a valid email.");
      }
    }
  }, [email]);

  useEffect(() => {
    if (!confirmPassword || !password) {
      setConfirmPasswordError("");
    } else {
      if (password !== confirmPassword) {
        setConfirmPasswordError("Passwords must match.");
      } else {
        setConfirmPasswordError("");
      }
    }
  }, [password, confirmPassword]);

  const clearset = () => {
    setEmail("");
    setName("");
    setConfirmPassword("");
    setConfirmPasswordError("");
    setPassword("");
    setEmailError("");
    setMess("");
  };

  var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  const validationForm = () => {
    if (name.length < 1) {
      return false;
    } else if (password.length < 8) {
      return false;
    } else if (format.test(password) === false) {
      return false;
    } else if (!password.match(/\d/)) {
      return false;
    } else if (confirmPassword !== password) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validationForm()) {
      const registered = {
        name: name,
        email: email,
        password: password,
        referralId: referralID,
      };
      axios
        .post(`${DOMAIN}/signup`, registered)
        .then((response) => {
          setResp(response.data.message);
          if (
            response.data.message ===
            "Verification Email has been sent to your given email."
          ) {
            clearset();
            handleOpen();
          }
        })
        .catch((err) => {
          console.error(err);
          setMess("Account already exists with given details.");
        });
    } else setMess("Validation Error!! Please fill the form correctly");
  };

  const [state] = useState({
    title: "Markoknow",
    titleTwo: "Welcomes you",

    titleThree: "To",
  });
  return (
    <>
      <div className="Signup_Form_container" style={{ background: "#fff" }}>
        {mess.length > 0 && (
          <div
            style={{ width: "21rem", margin: "auto" }}
            className="Alert_type"
          >
            <Alert severity="error">
              <AlertTitle>ERROR OCCURED</AlertTitle>
              <strong>{mess}</strong>
            </Alert>
          </div>
        )}

        <Grid container>
          <Grid item lg={6} md={12} sm={12} xs={12}>
            <div className="left_box_type">
              <h4 className="main-heading">
                <div className="titleSignup">{state.title}</div>
                <div className="titleTwoSignup">{state.titleTwo}</div>
                <div className="titleThreeSignup">{state.titleThree}</div>
              </h4>
              <div className="textSignup">
                <Typewriter
                  options={{
                    autoStart: true,
                    loop: true,
                    delay: 40,
                    strings: [
                      "its 25,000+ Community Platform for Founders, Investors & Learners",
                      "Learn , Network & Grow with Markoknow.",
                      "Startup Your Journey with Markoknow and make your passion a reality",
                    ],
                  }}
                />
              </div>
            </div>
          </Grid>
          <Grid item lg={5} md={12} sm={12} xs={12}>
            <div className="right_box_type">
              <form className="signup_form" onSubmit={handleSubmit}>
                <h3>SignUp</h3>

                <div style={{ margin: "20px", textAlign: "center" }}>
                  <LoginwithGoogle setIsAuth={setIsAuth} />
                </div>

                <TextField
                  style={{ paddingBottom: "15px", width: "100%" }}
                  value={name}
                  variant="outlined"
                  onChange={(e) => setName(e.target.value)}
                  type="text"
                  label="Username"
                />

                <span className="error">{emailError}</span>
                <TextField
                  style={{ paddingBottom: "15px", width: "100%" }}
                  value={email}
                  variant="outlined"
                  onChange={(e) => setEmail(e.target.value)}
                  type="email"
                  required
                  label="Email"
                  autoComplete="off"
                />

                <span className="error">{passwordError}</span>
                <TextField
                  style={{ paddingBottom: "15px", width: "100%" }}
                  value={password}
                  variant="outlined"
                  onChange={(e) => setPassword(e.target.value)}
                  type="password"
                  required
                  label="Password"
                />

                <span className="error">{confirmPasswordError}</span>
                <TextField
                  style={{ paddingBottom: "15px", width: "100%" }}
                  value={confirmPassword}
                  variant="outlined"
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  type="password"
                  label="Confirm Password"
                />

                <TextField
                  style={{ paddingBottom: "15px", width: "100%" }}
                  value={referralID}
                  variant="outlined"
                  onChange={(e) => setReferralID(e.target.value)}
                  type="text"
                  label="Referral Id"
                />
                <div>
                  Already a member?{" "}
                  <Link
                    exact="true"
                    to="/login"
                    style={{
                      color: "blue",
                    }}
                  >
                    click here
                  </Link>
                </div>
                <br />

                <div className="auth_button2">
                  <button
                    type="submit"
                    variant="contained"
                    className="btn-primary button_signup"
                  >
                    SignUp
                  </button>
                </div>
                <div>
                  By clicking on SignUp, you accept our{" "}
                  <Link
                    exact="true"
                    to="/terms_conditions"
                    style={{
                      color: "blue",
                    }}
                  >
                    Terms&Conditions
                  </Link>{" "}
                  &{" "}
                  <Link
                    exact="true"
                    to="/privacy_policy"
                    style={{
                      color: "blue",
                    }}
                  >
                    Privacy Policy
                  </Link>
                </div>
                <Modal
                  open={open}
                  onClose={handleClose}
                  aria-labelledby="simple-modal-title"
                  aria-describedby="simple-modal-description"
                >
                  {body}
                </Modal>
              </form>
            </div>
          </Grid>
          <Grid lg={1} md={0}></Grid>
        </Grid>
      </div>
    </>
  );
}

export default Signup;
